(() => {
  angular
    .module('gm.common.directives')
    .directive('gmModal', gmModalDirective);

  function gmModalDirective(
    $document,
    $rootScope,
    $timeout,
    ModalOverlay
  ) {
    'ngInject';

    const has = Object.prototype.hasOwnProperty;
    ModalOverlay.init();

    return {
      require: '?ngModel',
      restrict: 'E',
      scope: {
        isOpenModal: '=?',
        close: '&?',
        overlay: '@',
        event: '@',
        body: '@'
      },
      templateUrl: 'modules/common/directives/modal/modal.html',
      transclude: true,

      link(scope, element, attrs, ctrl) {
        let opened = false;
        let deregisterClick;

        const escHandler = (event) => {
          if (event.which === 27) {
            $timeout(close);
            event.stopPropagation();
          }
        };

        function open(data) {
          scope.modalData = data;
          $document.on('keyup', escHandler);

          if (!opened) {
            opened = true;

            if (scope.body) {
              element.detach().appendTo('body');
            }

            scope.$emit('modal:opened', scope.overlay);

            if (!has.call(attrs, 'block')) {
              deregisterClick = scope.$on('modal:overlay:click', close);
            }

            if (has.call(attrs, 'onOpen')) {
              scope.$eval(attrs.onOpen);
            }

            $timeout(() => scope.$broadcast('modal:data', data));
          }
        }

        function close() {
          $document.off('keyup', escHandler);

          if (opened) {
            opened = false;
            scope.$emit('modal:closed', scope.overlay);

            if (deregisterClick) {
              deregisterClick();
            }

            if (scope.close) {
              scope.close();
            }
          }
          if (has.call(attrs, 'ngModel')) {
            ctrl.$setViewValue(false);
          }
        }

        if (has.call(attrs, 'ngModel')) {
          scope.$watch(() => ctrl.$modelValue, (show) => {
            scope.isOpenModal = show;

            if (show) {
              open();
            } else {
              close();
            }
          });
        } else if (scope.event) {
          $rootScope.$on(`modal:${scope.event}:open`, (_event, data) => open(data));
          $rootScope.$on(`modal:${scope.event}:close`, close);
        }

        scope.$on('modal:close', close); // for using inside
        element.on('click', '.modal-button-close', close);
        scope.$on('$destroy', close);
        scope.isOpen = () => opened;

        scope.$on('$destroy', () => {
          if (scope.body) {
            element.remove();
          }
        });
      },
    };
  }
})();
